import React from 'react';
import TableTooltip from '@shared/Reports/TableTooltip';

const RoyaltyPaymentSelectionBar = ({
	selectedCount,
	canMarkPaid = false,
	canMarkUnpaid = false,
	paidDisabledReason,
	unpaidDisabledReason,
	onMarkPaid,
	onMarkUnpaid,
}) => {
	if (!selectedCount) return null;
	return (
		<div className="fixed bottom-[4rem] left-0 right-0 bg-slate-700 w-max lg:w-full lg:max-w-max mx-auto rounded-full text-white px-16 py-8 z-50">
			<div className="flex gap-10 md:gap-32 items-center">
				<div className="flex items-center gap-8">
					<span className="text-12 bg-white text-black rounded-full px-8 py-0 flex items-center justify-center">
						{selectedCount}
					</span>
					<span>Selected</span>
				</div>
				<div className="flex gap-8">
					{canMarkPaid ? (
						<button
							className="bg-slate-600 rounded-full md:px-16 md:py-8 px-8 py-4 whitespace-nowrap text-12"
							onClick={onMarkPaid}
							type="button"
						>
							Mark as Paid
						</button>
					) : (
						<TableTooltip title={paidDisabledReason || 'Action unavailable for current selection'}>
							<button
								className="disabled:opacity-40 bg-slate-600 rounded-full md:px-16 md:py-8 px-8 py-4 whitespace-nowrap text-12"
								disabled
								type="button"
							>
								Mark as Paid
							</button>
						</TableTooltip>
					)}
					{canMarkUnpaid ? (
						<button
							className="bg-slate-600 rounded-full md:px-16 md:py-8 px-8 py-4 whitespace-nowrap text-12"
							onClick={onMarkUnpaid}
							type="button"
						>
							Mark as Unpaid
						</button>
					) : (
						<TableTooltip title={unpaidDisabledReason || 'Action unavailable for current selection'}>
							<button
								className="disabled:opacity-40 bg-slate-600 rounded-full md:px-16 md:py-8 px-8 py-4 whitespace-nowrap text-12"
								disabled
								type="button"
							>
								Mark as Unpaid
							</button>
						</TableTooltip>
					)}
				</div>
			</div>
		</div>
	);
};

export default RoyaltyPaymentSelectionBar;
